var mnMN = {
  locale: 'mn_MN',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Нэгдүгээр сар', 'Хоёрдугаар сар', 'Гуравдугаар сар', 'Дөрөвдүгээр сар', 'Тавдугаар сар', 'Зургадугаар сар', 'Долдугаар сар', 'Наймдугаар сар', 'Есдүгээр сар', 'Аравдугаар сар', 'Арван нэгдүгээр сар', 'Арван хоёрдугаар сар'],
    monthList: ['Нэгдүгээр сар', 'Хоёрдугаар сар', 'Гуравдугаар сар', 'Дөрөвдүгээр сар', 'Тавдугаар сар', 'Зургадугаар сар', 'Долдугаар сар', 'Наймдугаар сар', 'Есдүгээр сар', 'Аравдугаар сар', 'Арван нэгдүгээр сар', 'Арван хоёрдугаар сар'],
    shortDayList: ['Ням', 'Да', 'Мя', 'Лха', 'Пү', 'Ба', 'Бя'],
    dayList: ['Ням', 'Да', 'Мя', 'Лха', 'Пү', 'Ба', 'Бя'],
    shortestDayList: ['Ням', 'Да', 'Мя', 'Лха', 'Пү', 'Ба', 'Бя']
  },
  'dynamic-date': {
    day: 'Өдөр',
    week: 'Долоо хоног',
    month: 'Сар',
    quarter: 'Хагас',
    year: 'Жил',
    before: 'Өмнө нь ${value}${unit}'
  },
  'auto-complete.empty': 'Дата байхгүй',
  'select.selected-count': '${count} нэгжийг сонголоо',
  'date-time-picker.date': 'Огноог сонгох',
  'image-view.zoom-out': 'Жижгэрүүлэх',
  'input.placeholder': 'Оруулна уу',
  'empty.text': 'Дата байхгүй',
  'date-picker.cancel': 'Цуцлах',
  'date-picker.end': 'Төгсгөлийн цаг',
  'cascader.empty': 'Дата байхгүй',
  'upload.drop': 'Файлыг энд чирэх эсвэл',
  'color.custom': 'Өнгийг тусгайлан өөрчлөх',
  'cascader.titles': ['Түвшин 1', 'Түвшин 2', 'Түвшин 3', 'Түвшин 4', 'Түвшин 5', 'Түвшин 6', 'Түвшин 7', 'Түвшин 8'],
  'date-comparison.error-target': 'Харьцуулахын төгсгөлийн цагийг сонгоорой',
  'transfer.empty': 'Дата байхгүй',
  'select.search.placeholder': 'Оруулна уу',
  'upload.click': 'Байршуулахын тулд дараарай',
  'date-time-picker.placeholder': 'Оруулна уу',
  'pager.jump': 'Дахин чиглүүлэх',
  'tree-select.placeholder': 'Оруулна уу',
  'dynamic-date.interval': 'Интервал',
  'modal.cancel': 'Цуцлах',
  'image-view.rotate': 'Эргэх',
  'tabs.more': 'Илүү их',
  'popover.ok': 'Баталгаажуулах',
  'transfer.placeholder': 'Оруулна уу',
  'date.month': 'сар',
  'select.selected': 'Сонгогдсон',
  'popover.cancel': 'Цуцлах',
  'image-view.prev': 'Өмнөх',
  'table.emptyText': 'Дата байхгүй',
  'date-time-picker.ok': 'Баталгаажуулах',
  'table.filter.confirm': 'Баталгаажуулах',
  'tree-select.empty': 'Дата байхгүй',
  'dynamic-date.fixed-date': 'Зассан огноо',
  'date-comparison.compare': 'Харьцуулах',
  'auto-complete.placeholder': 'Оруулна уу',
  'time-picker.placeholder': 'Цагийг сонгох',
  'date.month-first': true,
  'select.clear': 'Цэвэрлэх',
  'date.year': '${year}',
  'date-comparison.yoy': 'Өнгөрсөн оны энэ үе',
  'image-view.zoom-to-origin': 'Гарал үүсэл',
  'schedule.title': 'Огноо/Цаг',
  'schedule.clear': 'Цэвэрлэх',
  'date-time-picker.end': 'Дуусах огноо болон цагийг сонгоорой',
  'dynamic-date.customize': 'Тусгайлан өөрчлөх',
  'date-picker.apply': 'Хэрэглэх',
  'schedule.selected': 'Сонгосон цаг',
  'dynamic-date.dynamic-date': 'Динамик огноо',
  'select.placeholder': 'Сонгоно уу',
  'schedule.separator': ',',
  'cascader.search': 'Оруулна уу',
  'date-picker.invalid-range': 'Сонгосон хугацааны муж нь сонгож болох мужаас хэтэрсэн байна. Хүчинтэй нэгийг сонгоно уу.',
  'dynamic-date.date-preview': 'Огноог урьдчилан харах',
  'select.empty': 'Дата байхгүй',
  'image-view.next': 'Дараагийнх',
  'date-time-picker.now': 'Одоо',
  'date-time-picker.time': 'Цагийг сонгох',
  'tree.empty': 'Дата байхгүй',
  'pager.total': 'Нийт ${total} бичлэг',
  'image-view.zoom-in': 'Томруулах',
  'date-picker.placeholder': 'Огноог сонгох',
  'textarea.placeholder': 'Оруулна уу',
  'date.week': 'долоо хоног',
  'pager.size': '${count} бичлэг/хуудас',
  'modal.ok': 'Баталгаажуулах',
  'date-picker.start': 'Эхлэх цаг',
  'table.filter.reset': 'Дахин тохируулах',
  'image-view.zoom-to-fit': 'Тохирох',
  'pager.page.placeholder': 'Оруулна уу',
  'select.select-all': 'Бүгдийг сонгох',
  'list-viewer.empty': 'Дата байхгүй',
  'date-comparison.compare-text': 'Эсрэг',
  'transfer.source': 'Эх сурвалжийн жагсаалт',
  'date-time-picker.start': 'Эхлэх огноо болон цагийг сонгоорой',
  'date-comparison.error-source': 'Харьцуулахын тулд эхлэх цагийг сонгоорой',
  'upload.error.overflow-count': 'Файлын хамгийн их тооноос хэтэрлээ',
  'date-comparison.placeholder': 'Эхлэх цаг - Төгсгөлийн цаг',
  'time-range-picker.placeholder': 'Эхлэх цаг - Төгсгөлийн цаг',
  'date-comparison.mom': 'Өмнөх хугацаатай харьцууллаа',
  'transfer.target': 'Зорилтот жагсаалт'
};
export default mnMN;